export default "__VITE_ASSET__7a1e9c48__"